<script setup lang="ts">
import type { CmsElementCustomerService } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsElementCustomerService;
}>();

const { heading, subHeading, servicesCollection } = props.content?.config

</script>
<template>
  <section class="section section--solid section-features section-features--alt section-main" :style="props.style" :class="props.class">
    <div class="container">
      <header class="section__head">
        <h2>{{ heading.value }}</h2>

        <h6 v-html="subHeading.value"></h6>
      </header><!-- /.section__head -->

      <div class="section__body">
        <div class="features-secondary section__features">
          <div class="row justify-content-center">
            <div class="col-6 col-md-4" v-for="(service, index) in servicesCollection.value" :key="index">
              <div class="feature feature--alt features__feature">
                <a :href="service?.link?.url">
                  <div class="feature__image">
                    <NuxtImg format="webp" loading="lazy" :src="service?.icon?.url?.replace(/ /g, '%20')" alt="" width="125" height="110"></NuxtImg>
                  </div><!-- /.feature__image -->

                  <p>{{ service.text }}</p>
                </a>
              </div>
            </div>
          </div>
        </div><!-- /.features-/-secondary section__features -->
      </div><!-- /.section__body -->
    </div><!-- /.container -->
  </section>
</template>